export enum HandMoveEnum {
    hours = 'hours',
    minutes = 'minutes',
    seconds = 'seconds',
}
